import { BaseModalLayoutUniDriver } from '../BaseModalLayout/BaseModalLayout.uni.driver';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface MessageModalLayoutUniDriver extends BaseModalLayoutUniDriver {}

export declare const messageModalLayoutDriverFactory: (
  base: BaseUniDriver,
) => MessageModalLayoutUniDriver;
